import { memo } from 'react';
import HomeIcon from '@material-ui/icons/Home';
import Fab from '@material-ui/core/Fab';
import { LinkRouter } from '../link/Link';
import Tooltip from '@material-ui/core/Tooltip';

function ButtonHome() {

    return (
        <LinkRouter to='/'>
            <Tooltip title="Menu Inicial" style={{position: "relative", zIndex:"3"}} aria-label="add">
                <Fab color="primary" size="small" >
                    <HomeIcon />
                </Fab>
            </Tooltip>
        </LinkRouter>
    );
}

export default memo(ButtonHome);